<template>
  <div class="excelSlot" @click="$emit('downloadExcel', true)">
    <!-- <a :href="link" target="_top"> -->
    <img class="excelIcon" src="@/assets/images/excel-icon.svg" alt="excel" />
    <!-- </a> -->
  </div>
</template>

<script>
export default {
  props: {
    link: null,
  },
  watch: {
    link(val) {
      if (val != null) {
        window.open(val, '_blank')
      }
    },
  },
}
</script>

<style scoped>
.excelIcon {
  cursor: pointer;
}
.excelSlot {
  margin-left: 10px;
  display: flex;
  width: 40px;
  height: 40px;
  background: #eff2f7;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
}

@media (max-width: 378px) {
  .excelSlot {
    width: 30px !important;
    height: 30px !important;
  }
}
</style>
